import React, { useEffect, useState } from "react";
import { Form, Button, ListGroup, Badge } from "react-bootstrap";
import api from "../../api";

// Phase 5, §32. Lets an Admin add an active, handler-supported metric to a
// profile. Never allows an arbitrary formula — only a pick from the
// existing catalogue.
export default function PerformanceMetricSelector({ excludeIds = [], onAdd }) {
  const [metrics, setMetrics] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/performance-metrics", { params: { is_active: 1, pageSize: 200 } })
      .then((res) => setMetrics(Array.isArray(res.data?.data) ? res.data.data : []))
      .catch((err) => console.error("Fetch metrics error:", err));
  }, []);

  const available = metrics.filter((m) => !excludeIds.includes(m.id) && (!search || m.name.toLowerCase().includes(search.toLowerCase()) || m.code.toLowerCase().includes(search.toLowerCase())));

  return (
    <div>
      <Form.Control size="sm" placeholder="Search metrics to add..." value={search} onChange={(e) => setSearch(e.target.value)} className="mb-2" />
      <ListGroup style={{ maxHeight: 220, overflowY: "auto" }}>
        {available.length === 0 && <div className="text-muted small p-2">No metrics available to add.</div>}
        {available.map((m) => (
          <ListGroup.Item key={m.id} className="d-flex justify-content-between align-items-center">
            <span>
              {m.name} <span className="text-muted small">({m.code})</span>{" "}
              {!m.has_calculation_handler && <Badge bg="danger" className="ms-1">No handler</Badge>}
              {m.direction === "INFORMATIONAL_ONLY" && <Badge bg="secondary" className="ms-1">Informational</Badge>}
            </span>
            <Button size="sm" variant="outline-primary" disabled={!m.has_calculation_handler} onClick={() => onAdd(m)}>Add</Button>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}
